<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="col-md-12">
  <fieldset>
    <legend class="row">
      <div class="col-md-6 m-auto">General Merchant Info</div>
      <div class="col-md-6">
        <button
          class="btn btn-primary float-right"
          *ngIf="
            merchant.accountDetails.worldPayAccountDetails
              .backingWPMerchantExists &&
            isUserBase() &&
            isWorldPay() &&
            isMerchantActive() &&
            !editable
          "
          (click)="setEditable(true)"
        >
          <span>
            <fa-icon [icon]="faEditPencil"></fa-icon>
          </span>
          Edit General Info
        </button>
      </div>
    </legend>

    <div class="mt-3">
      <app-general-info
        *ngIf="!editable"
        [merchant]="merchant"
      ></app-general-info>
    </div>

    <div class="mt-3" *ngIf="editable">
      <form
        name="generalInfoFormControl"
        class="form-horizontal"
        novalidate
        [formGroup]="wpGeneralInfoForm"
        (submit)="updateElementMerchant()"
      >
        <app-general-info-edit
          [parentGroup]="wpGeneralInfoForm"
          [generalInfo]="this.generalInfoFormGroup"
          [merchant]="merchant"
          [hiddenField]="false"
        >
        </app-general-info-edit>
        <app-edit-buttons
          [buttonName]="buttonName"
          [actionInProgress]="actionInProgress"
          [formInvalid]="generalInfoFormGroup.invalid"
          (editableEvent)="receiveEditEvent($event)"
        ></app-edit-buttons>
      </form>
    </div>
  </fieldset>
</div>
